/*
* Table Data - add labels to the table cells in mobile version.
* */
export const tableDataMobileLabels = () => {
    const labels = Array.from(document.querySelectorAll('.c-data-table__header .header-item'));
    let labelsNames = [];
    for (let i = 0; i < labels.length; i++) {
        labelsNames.push(labels[i]['innerText']);
    }

    const rowsData = Array.from(document.querySelectorAll('.c-data-table__row'));

    rowsData.forEach((tableRow) => {
        const items = Array.from(tableRow.querySelectorAll('.row-item'));
        let itemCounter = 0;

        items.forEach((item) => {
            let label = document.createElement('div');
            label.classList.add('row-item__label');
            label.innerHTML = (labelsNames[itemCounter]) ? labelsNames[itemCounter] : '';

            let fragment = document.createDocumentFragment();
            fragment.appendChild(label);
            item.prepend(fragment);

            itemCounter++;
        });
    });
};
// tableDataMobileLabels();
